var map = {
	"./br.svg": 1596,
	"./cs.svg": 1597,
	"./de.svg": 1598,
	"./en.svg": 1599,
	"./es.svg": 1600,
	"./fi.svg": 1601,
	"./fr.svg": 1602,
	"./hu.svg": 1603,
	"./it.svg": 1604,
	"./nl.svg": 1605,
	"./no.svg": 1606,
	"./pl.svg": 1607,
	"./ro.svg": 1608,
	"./ru.svg": 1609,
	"./sk.svg": 1610,
	"./sv.svg": 1611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1595;